import * as React from "react";

import { AgentThreadsTable } from "@/Agents/Threads/AgentThreadsTable";
import { LaunchAgentMenu } from "@/shared/components/agentThread/LaunchAgentMenu";
import type { Filter } from "@/shared/components/ResourceView";

import { useSessionOutletContext } from "../useSessionOutletContext";

import styles from "./SessionAgentThreads.module.css";

/**
 * The session's Agents tab: the agent threads about the session, and a Launch
 * menu of the org's agents that take a session. A thread is listed when one of
 * its goals targeted the session, or when the user had the session open while
 * starting the thread or sending it a message. The ``subject_id`` scope pins
 * the list to those threads; the user's filters narrow it but cannot widen it.
 *
 * Imports ``AgentThreadsTable`` from the Agents feature, as the dataset's
 * Agents tab does.
 */
export function SessionAgentThreads() {
  const { session } = useSessionOutletContext();
  const sessionId = session.session_id;

  const scope = React.useMemo<Filter[]>(
    () => [
      {
        type: "string",
        field: "subject_id",
        comparator: "EQUALS",
        values: [sessionId],
      },
    ],
    [sessionId],
  );

  return (
    <div className={styles.tab}>
      <AgentThreadsTable
        scope={scope}
        noData={{ title: "No threads for this session yet" }}
        trailingActions={
          <LaunchAgentMenu subject={{ kind: "session", id: sessionId }} />
        }
      />
    </div>
  );
}
